import { socket } from '../../../../../shared/scripts/EntryShared.ts';
import { UIReplayController } from '../../../../../shared/scripts/ui_replay/UIReplayController.ts';
import { getReplayInitiationData, getReplayUrlActionIndex } from '../../../../../shared/scripts/ui_replay/ReplayUrlUtilities.ts';
import { UIGameSpriteHandler } from '../../../../../shared/scripts/UIGameSpriteHandler.ts';
import { uiManager } from '../../../EntryHomepage.ts';
import { Scene } from '../../../ui_html/UISceneTypes.ts';
export class UIDReplaySceneController {
    loadReplay(gameId, playerColor) {
        var _this_replayController;
        (_this_replayController = this.replayController) === null || _this_replayController === void 0 ? void 0 : _this_replayController.destroy();
        this.replayController = undefined;
        void UIGameSpriteHandler.continueAfterAssetsLoad(async ()=>{
            try {
                const replayUrl = new URL(`https://colonist.io/replay?gameId=${gameId}&playerColor=${playerColor}`);
                const replayInitiationData = await getReplayInitiationData(replayUrl.href);
                const replayActionIndex = getReplayUrlActionIndex(replayUrl.href);
                const isLiveReplay = false;
                this.replayController = new UIReplayController(replayInitiationData, socket.actionController, isLiveReplay, replayActionIndex);
                uiManager === null || uiManager === void 0 ? void 0 : uiManager.sceneController.loadScene(Scene.Game);
            } catch (e) {
                uiManager === null || uiManager === void 0 ? void 0 : uiManager.sceneController.loadScene(Scene.DiscordStore);
            }
        });
    }
}
